import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Mousewheel, Navigation } from "swiper";
import { Badge } from "react-bootstrap";

const TableHeaderSwiper = ({
  title,
  setActiveCampaignGroup,
  activeCampaignGroup,
  className,
}) => {
  useEffect(() => {
    if (title && title.length > 0) {
      setActiveCampaignGroup({
        index: 0,
        id: title[0].id,
      });
    }
  }, [title, setActiveCampaignGroup]);

  return (
    <div
      className={`overflow-hidden d-slider1 flex-grow-1 me-0 me-md-3 ${className}`}
    >
      <Swiper
        as="ul"
        className="p-0 m-0 swiper-wrapper list-inline tableHeaderSwiper"
        modules={[Navigation, Mousewheel]}
        data-aos="fade-up"
        data-aos-delay="700"
        slidesPerView="auto"
        mousewheel={{ sensitivity: 1 }}
        spaceBetween={10}
      >
        {title &&
          title.map((item, index) => {
            return (
              <SwiperSlide className="cursor-pointer" key={index}>
                <Badge
                  pill
                  bg="light text-primary"
                  onClick={() =>
                    setActiveCampaignGroup({
                      index: index,
                      id: item?.id,
                    })
                  }
                  className={`border w-auto  ${
                    index === activeCampaignGroup.index
                      ? "border-primary"
                      : "border-light"
                  } `}
                >
                  {item.group_title}
                </Badge>
              </SwiperSlide>
            );
          })}
      </Swiper>
    </div>
  );
};

export default TableHeaderSwiper;
